module.exports = __webpack_public_path__ + "img/iocn-block.bd4f31e4.png";